import AboutSection from "../Sections/AboutSection";
// import AboutFooter from "../Sections/AboutFooter";
import BottomFooterAbout from "../Sections/bottomFooterAbout";
import WhatsappWidget from "../Components/Whatsapp Widget/WhatsappWidget";

function AboutUs() {
  return (
    <>
      <AboutSection />
      {/* <AboutFooter /> */}
      <BottomFooterAbout />
      <WhatsappWidget />
    </>
  );
}

export default AboutUs;
